import type { Comic } from '@/types/comic';

export const comics: Comic[] = [
  {
    id: 'c01',
    title: '我和社长的契约恋爱',
    author: '白露',
    categories: ['romance', 'urban'],
    region: '韩国',
    status: '连载中',
    description:
      '为了偿还家族债务，我被迫与冷峻的集团社长签下为期一年的契约婚姻。本以为只是一场心照不宣的交易，却在他的步步紧逼下逐渐沦陷，原来这场契约里，动心的从来不止我一个人。',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romantic%20comic%20cover%20of%20an%20elegant%20office%20couple%20standing%20back%20to%20back%2C%20soft%20lavender%20studio%20background%2C%20warm%20rim%20light%2C%20clean%20modern%20line%20art%2C%20muted%20purple%20and%20peach%20palette%2C%20vertical%20book%20cover%20composition&width=600&height=800&seq=hanman-cover-01&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Stylized%20romantic%20webtoon%20key%20visual%20of%20a%20couple%20under%20soft%20violet%20city%20lights%20at%20dusk%2C%20dreamy%20gradient%20sky%2C%20cinematic%20wide%20composition%2C%20painterly%20modern%20illustration%2C%20purple%20and%20warm%20amber%20tones%2C%20negative%20space%20on%20the%20left&width=1600&height=900&seq=hanman-banner-01&orientation=landscape',
    views: 4820000,
    favorites: 128000,
    updatedAt: '2026-10-13',
    chapterCount: 86,
  },
  {
    id: 'c02',
    title: '冷面骑士的守护',
    author: '夜幕星尘',
    categories: ['fantasy', 'romance'],
    region: '韩国',
    status: '连载中',
    description:
      '帝国最冷酷的骑士团长立誓终生不娶，却在雪夜里救下了身负诅咒的少女。当剑刃与温柔相撞，一场跨越生死的守护悄然开始，而他冰冷的铠甲之下，藏着一颗从未冷却的心。',
    cover:
      'https://readdy.ai/api/search-image?query=Fantasy%20webtoon%20comic%20cover%20of%20a%20silver%20armored%20knight%20protecting%20a%20young%20woman%20in%20falling%20snow%2C%20cold%20moonlight%2C%20dramatic%20shadows%2C%20elegant%20line%20art%2C%20steel%20blue%20and%20violet%20palette%2C%20vertical%20book%20cover&width=600&height=800&seq=hanman-cover-02&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Epic%20fantasy%20webtoon%20key%20visual%20of%20a%20lone%20knight%20standing%20on%20a%20snowy%20battlefield%20under%20an%20aurora%2C%20cinematic%20wide%20composition%2C%20dramatic%20cool%20lighting%2C%20painterly%20modern%20illustration%2C%20violet%20and%20ice%20blue%20tones%2C%20negative%20space%20on%20the%20right&width=1600&height=900&seq=hanman-banner-02&orientation=landscape',
    views: 3210000,
    favorites: 96000,
    updatedAt: '2026-10-12',
    chapterCount: 120,
  },
  {
    id: 'c03',
    title: '深夜便利店',
    author: '林九',
    categories: ['suspense', 'urban'],
    region: '韩国',
    status: '连载中',
    description:
      '凌晨三点的便利店，总会有奇怪的客人推门而入。值夜班的我逐渐发现，每一个走进来的人都带着不为人知的秘密，而货架上那瓶永远卖不出去的可乐，似乎和我的过去有关。',
    cover:
      'https://readdy.ai/api/search-image?query=Mystery%20webtoon%20comic%20cover%20of%20a%20glowing%20convenience%20store%20at%20midnight%20with%20a%20lone%20silhouette%20at%20the%20counter%2C%20rain%20on%20glass%2C%20neon%20reflections%2C%20moody%20atmosphere%2C%20cool%20violet%20and%20teal%20palette%2C%20vertical%20book%20cover&width=600&height=800&seq=hanman-cover-03&orientation=portrait',
    views: 2140000,
    favorites: 61000,
    updatedAt: '2026-10-11',
    chapterCount: 64,
  },
  {
    id: 'c04',
    title: '魔法学院的新生',
    author: '月见草',
    categories: ['fantasy', 'school'],
    region: '韩国',
    status: '连载中',
    description:
      '被误认为最强魔法师继承人的我，稀里糊涂地进入了皇家魔法学院。在这里，友情、竞争与阴谋交织成一场盛大的青春冒险，而我只是想安安静静地混到毕业而已。',
    cover:
      'https://readdy.ai/api/search-image?query=Vibrant%20fantasy%20school%20webtoon%20cover%20of%20a%20young%20mage%20holding%20a%20glowing%20spellbook%20in%20front%20of%20a%20grand%20floating%20academy%2C%20magic%20sparkles%2C%20warm%20golden%20light%2C%20clean%20modern%20line%20art%2C%20violet%20and%20amber%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-04&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Grand%20magic%20academy%20webtoon%20key%20visual%20with%20towering%20spires%20and%20floating%20crystals%20in%20a%20twilight%20sky%2C%20cinematic%20wide%20composition%2C%20glowing%20rune%20lights%2C%20painterly%20modern%20illustration%2C%20violet%20and%20gold%20tones%2C%20negative%20space%20in%20the%20center&width=1600&height=900&seq=hanman-banner-04&orientation=landscape',
    views: 3920000,
    favorites: 118000,
    updatedAt: '2026-10-13',
    chapterCount: 95,
  },
  {
    id: 'c05',
    title: '我的野蛮同桌',
    author: '小满',
    categories: ['school', 'comedy', 'romance'],
    region: '中国',
    status: '连载中',
    description:
      '转学第一天，我就撞上了全校最不好惹的女生。她拳头比谁都硬，笑起来却比谁都甜，我的高中生活就此天翻地覆，而那张被撕坏的课桌，成了我们故事的开始。',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20high%20school%20webtoon%20cover%20of%20a%20tough%20smiling%20girl%20in%20uniform%20and%20a%20startled%20boy%20sharing%20a%20school%20desk%2C%20bright%20classroom%20light%2C%20cute%20expressive%20faces%2C%20clean%20modern%20line%20art%2C%20violet%20and%20peach%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-05&orientation=portrait',
    views: 1760000,
    favorites: 52000,
    updatedAt: '2026-10-10',
    chapterCount: 72,
  },
  {
    id: 'c06',
    title: '重生之豪门千金',
    author: '沈知意',
    categories: ['urban', 'romance'],
    region: '中国',
    status: '连载中',
    description:
      '一觉醒来，我重生回被赶出家门的那一天。这一次，我不会再做任人摆布的棋子。豪门恩怨、商场博弈，就让我亲手改写这早已注定的结局，也让那些辜负我的人付出代价。',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20urban%20webtoon%20cover%20of%20a%20confident%20young%20heiress%20in%20a%20red%20gown%20before%20a%20luxury%20skyline%20at%20night%2C%20dramatic%20lighting%2C%20glamorous%20modern%20line%20art%2C%20plum%20and%20gold%20palette%2C%20vertical%20book%20cover&width=600&height=800&seq=hanman-cover-06&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Luxury%20city%20skyline%20webtoon%20key%20visual%20at%20night%20with%20a%20silhouetted%20elegant%20woman%20looking%20over%20glass%20buildings%2C%20cinematic%20wide%20composition%2C%20warm%20golden%20windows%2C%20painterly%20modern%20illustration%2C%20deep%20violet%20and%20amber%20tones&width=1600&height=900&seq=hanman-banner-06&orientation=landscape',
    views: 5230000,
    favorites: 143000,
    updatedAt: '2026-10-13',
    chapterCount: 138,
  },
  {
    id: 'c07',
    title: '剑与蔷薇的黄昏',
    author: '橘右京',
    categories: ['fantasy', 'action'],
    region: '日本',
    status: '连载中',
    description:
      '没落的骑士团只剩最后一名成员。为了找回失落的圣剑，他带着一朵不会枯萎的蔷薇，踏上了遍布魔物的黄昏大陆。传说尽头，等着他的不只是荣光，还有一个被遗忘的誓言。',
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20fantasy%20webtoon%20cover%20of%20a%20battle%20worn%20swordsman%20holding%20a%20red%20rose%20amid%20an%20orange%20sunset%20ruins%2C%20drifting%20petals%2C%20dramatic%20silhouette%2C%20bold%20modern%20line%20art%2C%20violet%20and%20crimson%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-07&orientation=portrait',
    views: 2680000,
    favorites: 79000,
    updatedAt: '2026-10-12',
    chapterCount: 101,
  },
  {
    id: 'c08',
    title: '校园怪谈研究会',
    author: '夜行萤',
    categories: ['school', 'suspense'],
    region: '韩国',
    status: '连载中',
    description:
      '研究“不存在的教室”的社团里，只有我一个人是活人。当午夜钟声敲响，走廊尽头的那扇门又一次缓缓打开。我必须在天亮之前找出真相，否则下一个消失的，就会是我。',
    cover:
      'https://readdy.ai/api/search-image?query=Eerie%20school%20horror%20webtoon%20cover%20of%20an%20empty%20night%20corridor%20with%20a%20faintly%20glowing%20classroom%20door%20at%20the%20end%2C%20cold%20moonlight%2C%20ghostly%20mist%2C%20moody%20modern%20line%20art%2C%20violet%20and%20grey%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-08&orientation=portrait',
    views: 1980000,
    favorites: 58000,
    updatedAt: '2026-10-11',
    chapterCount: 58,
  },
  {
    id: 'c09',
    title: '追妻火葬场',
    author: '温以宁',
    categories: ['romance', 'urban'],
    region: '中国',
    status: '连载中',
    description:
      '离婚那天，他将文件冷冰冰地甩在我面前。三年后我功成名就归来，他跪在雨里说，能不能再给我一次机会。这一次，轮到他来体会，什么叫做爱而不得。',
    cover:
      'https://readdy.ai/api/search-image?query=Emotional%20romance%20webtoon%20cover%20of%20a%20rain%20soaked%20man%20kneeling%20before%20a%20composed%20elegant%20woman%20with%20an%20umbrella%2C%20night%20city%20lights%2C%20dramatic%20tears%2C%20refined%20modern%20line%20art%2C%20violet%20and%20amber%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-09&orientation=portrait',
    views: 4470000,
    favorites: 121000,
    updatedAt: '2026-10-13',
    chapterCount: 92,
  },
  {
    id: 'c10',
    title: '天选异兽录',
    author: '苍岚',
    categories: ['fantasy', 'action'],
    region: '韩国',
    status: '连载中',
    description:
      '在这个人与异兽共存的世界，只有被神选中的孩子才能召唤守护兽。而我召唤出的，竟是一只只会睡懒觉的橘猫。直到某天，它在我耳边轻声说：真正的战斗，才刚刚开始。',
    cover:
      'https://readdy.ai/api/search-image?query=Adventure%20webtoon%20cover%20of%20a%20young%20beast%20tamer%20with%20a%20lazy%20orange%20cat%20on%20his%20shoulder%20surrounded%20by%20glowing%20magical%20creatures%2C%20forest%20light%2C%20vivid%20modern%20line%20art%2C%20violet%20and%20emerald%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-10&orientation=portrait',
    views: 3020000,
    favorites: 88000,
    updatedAt: '2026-10-12',
    chapterCount: 110,
  },
  {
    id: 'c11',
    title: '我们的青春不散场',
    author: '夏南枝',
    categories: ['school', 'romance'],
    region: '中国',
    status: '已完结',
    description:
      '毕业照里少了一个人。十年后的同学会上，我们终于找回了那段被时光藏起来的青春，以及那句迟到太久的告白。有些人错过了十年，却从未真正离开过。',
    cover:
      'https://readdy.ai/api/search-image?query=Nostalgic%20school%20romance%20webtoon%20cover%20of%20a%20graduation%20photo%20with%20one%20missing%20friend%20and%20cherry%20blossoms%20falling%20over%20a%20schoolyard%2C%20warm%20afternoon%20light%2C%20gentle%20modern%20line%20art%2C%20violet%20and%20pink%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-11&orientation=portrait',
    views: 2330000,
    favorites: 71000,
    updatedAt: '2026-09-28',
    chapterCount: 60,
  },
  {
    id: 'c12',
    title: '逆天剑尊',
    author: '墨北寒',
    categories: ['historical', 'action', 'fantasy'],
    region: '中国',
    status: '连载中',
    description:
      '一代剑尊渡劫失败，重生为家族里最不起眼的废柴少年。前世我剑指苍穹，今生我要这天地都为我让路。当宿敌再次出现，他笑着说：这一次，换我来做你的对手。',
    cover:
      'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20webtoon%20cover%20of%20a%20young%20swordsman%20drawing%20a%20glowing%20sword%20on%20a%20mountain%20peak%20with%20clouds%20and%20thunder%2C%20dramatic%20wind%2C%20bold%20ink%20style%20line%20art%2C%20violet%20and%20jade%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-12&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Epic%20xianxia%20webtoon%20key%20visual%20of%20a%20sword%20immortal%20standing%20among%20floating%20mountains%20and%20clouds%20with%20lightning%2C%20cinematic%20wide%20composition%2C%20ink%20wash%20atmosphere%2C%20violet%20and%20jade%20tones%2C%20negative%20space%20in%20the%20center&width=1600&height=900&seq=hanman-banner-12&orientation=landscape',
    views: 3890000,
    favorites: 104000,
    updatedAt: '2026-10-11',
    chapterCount: 156,
  },
  {
    id: 'c13',
    title: '无人生还的公寓',
    author: '骨缇',
    categories: ['suspense', 'urban'],
    region: '韩国',
    status: '连载中',
    description:
      '搬进这栋公寓的第一天，管理员就告诉我：不要数楼层，不要在电梯里看镜子，也不要相信任何敲门的人。第一周，我以为这只是都市传说，直到我发现，我的邻居们……从来没有变过。',
    cover:
      'https://readdy.ai/api/search-image?query=Chilling%20horror%20webtoon%20cover%20of%20a%20dim%20old%20apartment%20building%20stairwell%20with%20a%20single%20flickering%20ceiling%20light%2C%20shadowy%20figures%2C%20damp%20walls%2C%20cold%20grainy%20modern%20line%20art%2C%20violet%20and%20slate%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-13&orientation=portrait',
    views: 1650000,
    favorites: 47000,
    updatedAt: '2026-10-10',
    chapterCount: 49,
  },
  {
    id: 'c14',
    title: '大小姐与保镖',
    author: '尹夏',
    categories: ['romance', 'action'],
    region: '韩国',
    status: '连载中',
    description:
      '她是张扬跋扈的财阀千金，他是沉默寡言的贴身保镖。枪声响起的那一刻，她才发现，他一直站在离心脏最近的地方，而那些她以为的巧合，全是他不动声色的守护。',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20romance%20webtoon%20cover%20of%20a%20bold%20heiress%20and%20her%20tall%20quiet%20bodyguard%20in%20a%20suit%2C%20city%20night%20bokeh%2C%20protective%20pose%2C%20clean%20sleek%20line%20art%2C%20violet%20and%20amber%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-14&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Stylish%20action%20romance%20webtoon%20key%20visual%20of%20a%20bodyguard%20shielding%20an%20heiress%20in%20a%20neon%20rainy%20street%2C%20cinematic%20wide%20composition%2C%20dramatic%20rim%20light%2C%20violet%20and%20amber%20tones%2C%20negative%20space%20on%20the%20left&width=1600&height=900&seq=hanman-banner-14&orientation=landscape',
    views: 2760000,
    favorites: 82000,
    updatedAt: '2026-10-13',
    chapterCount: 88,
  },
  {
    id: 'c15',
    title: '星际拾荒者',
    author: '零号航标',
    categories: ['fantasy', 'action'],
    region: '日本',
    status: '连载中',
    description:
      '在被遗弃的星域里，我驾驶破旧的拾荒船寻找可回收的残骸。直到某天，我从一艘千年沉船中唤醒了一个不该存在的信号，而这个信号，正被整个银河悬赏追捕。',
    cover:
      'https://readdy.ai/api/search-image?query=Science%20fantasy%20webtoon%20cover%20of%20a%20scavenger%20in%20a%20worn%20spacesuit%20floating%20before%20a%20giant%20derelict%20starship%2C%20deep%20space%20nebula%2C%20glowing%20signal%20light%2C%20sleek%20modern%20line%20art%2C%20violet%20and%20cyan%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-15&orientation=portrait',
    views: 1470000,
    favorites: 41000,
    updatedAt: '2026-10-09',
    chapterCount: 77,
  },
  {
    id: 'c16',
    title: '恋爱脑袋的日记',
    author: '奶油猫',
    categories: ['romance', 'comedy', 'school'],
    region: '韩国',
    status: '连载中',
    description:
      '母胎单身的我立志要谈一场甜甜的恋爱。可每一次心动都以社死告终，我的恋爱日记，全被写成了爆笑事故现场。也许爱情没来，但快乐先到了。',
    cover:
      'https://readdy.ai/api/search-image?query=Cute%20comedy%20romance%20webtoon%20cover%20of%20a%20blushing%20student%20hiding%20behind%20a%20diary%20with%20chibi%20hearts%20and%20question%20marks%20around%2C%20bright%20cheerful%20classroom%2C%20playful%20line%20art%2C%20violet%20and%20peach%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-16&orientation=portrait',
    views: 1920000,
    favorites: 63000,
    updatedAt: '2026-10-12',
    chapterCount: 66,
  },
  {
    id: 'c17',
    title: '沉默的证词',
    author: '苏晚城',
    categories: ['suspense'],
    region: '韩国',
    status: '已完结',
    description:
      '唯一的目击者是个哑巴，唯一的证据是一段被抹去的录像。十年悬案重启，真相藏在每个人沉默的证词里。当最后一块拼图落下，凶手就在我们中间。',
    cover:
      'https://readdy.ai/api/search-image?query=Crime%20thriller%20webtoon%20cover%20of%20a%20detective%20examining%20a%20broken%20camera%20lens%20under%20a%20single%20interrogation%20lamp%2C%20cold%20shadowy%20room%2C%20tense%20atmosphere%2C%20sharp%20modern%20line%20art%2C%20violet%20and%20steel%20grey%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-17&orientation=portrait',
    views: 2540000,
    favorites: 74000,
    updatedAt: '2026-09-30',
    chapterCount: 54,
  },
  {
    id: 'c18',
    title: '王妃倾城',
    author: '顾青梧',
    categories: ['historical', 'romance'],
    region: '中国',
    status: '连载中',
    description:
      '一朝穿越，我从现代法学生变成摄政王府上不受宠的王妃。既然宫墙困住了我，那我就用律法，重新写下这王朝的规矩。斗智斗勇之间，那个冷面王爷似乎也改变了主意。',
    cover:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20romance%20webtoon%20cover%20of%20a%20graceful%20princess%20in%20flowing%20violet%20hanfu%20amid%20red%20lanterns%20and%20palace%20corridors%2C%20elegant%20ink%20style%20line%20art%2C%20violet%20and%20gold%20palette%2C%20vertical%20cover&width=600&height=800&seq=hanman-cover-18&orientation=portrait',
    views: 3360000,
    favorites: 99000,
    updatedAt: '2026-10-13',
    chapterCount: 124,
  },
];